import { createReducer, on } from '@ngrx/store';
import { cleanAccountFeature, loadAccountFeaturesFinished } from './account.actions';
import { FeatureMapUserAccount } from '../../../admin/interfaces/user-accout.interface';

export interface AccountFeatureState {
    accountFeatures: FeatureMapUserAccount | null;
}

export const initialAccountFeatureState: AccountFeatureState = {
    accountFeatures: null
};

export const accountFeatureReducer = createReducer(
    initialAccountFeatureState,
    on(loadAccountFeaturesFinished, (state, { accountFeatures }) => ({
        ...state,
        accountFeatures
    })),
    on(cleanAccountFeature, () => initialAccountFeatureState)
);
